type ComponentWithPosition = {
  data?: {
    elementPosition?: {
      pagination?: number
      mobilePosition?: number
      desktopPosition?: number
    }
  }
}

export const filterComponentsForPosition = <T extends ComponentWithPosition>(
  components: T[],
  isMobile: boolean
) => {
  const componentsBySlot = new Map<string, T>()

  components.forEach((component) => {
    const position = component.data?.elementPosition

    if (
      position?.pagination === undefined ||
      position?.mobilePosition === undefined ||
      position?.desktopPosition === undefined
    ) {
      return
    }

    const slotPosition = isMobile
      ? position.mobilePosition
      : position.desktopPosition

    const slotKey = `${position.pagination}-${slotPosition}`

    const existingComponent = componentsBySlot.get(slotKey)

    if (!existingComponent) {
      componentsBySlot.set(slotKey, component)
    }
  })

  return Array.from(componentsBySlot.values())
}
